import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Home from "./pages/Home";
import ProductInputPage from "./pages/ProductInputPage";
import Cart from "./components/Cart";
import CheckoutForm from "./components/CheckoutForm";
import OrderSuccess from "./pages/OrderSuccess";
import OrderFail from "./pages/OrderFail";
import OrderCancel from "./pages/OrderCancel";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import RefundCancellationPolicy from "./components/RefundCancellationPolicy";
import RefundApplication from "./components/RefundApplication";



import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/* ---------------- App Content (inside Router) ---------------- */

function AppContent() {
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState("home");
  const [selectedProduct, setSelectedProduct] = useState(null);

  // ✅ restore cart from localStorage
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const [editIndex, setEditIndex] = useState(null);
  const [isCartOpen, setIsCartOpen] = useState(true);

  // ✅ sync cart → localStorage
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // ✅ auto open cart if items exist
  useEffect(() => {
    if (cart.length > 0) {
      setIsCartOpen(true);
    }
  }, [cart]);

  // ✅ THE FIX: clear cart on success route
  useEffect(() => {
    if (location.pathname === "/order-success") {
      setCart([]);
      localStorage.removeItem("cart");
    }
  }, [location.pathname]);

  const handleProductSelect = (product) => {
    setSelectedProduct(product);
    setCurrentPage("product");
  };

  

  const handleAddToCart = (newItem) => {
  if (cart.length > 0) {
    const confirmReplace = window.confirm(
      "Your cart already contains a policy. Would you like to replace it with this new selection?"
    );
    if (confirmReplace) {
      setCart([newItem]); // Replace existing with new
    }
    setCurrentPage("home");
  }
  setCart([newItem]); // Add if cart is empty
  setCurrentPage("home");
};

  const handleRemove = (index) =>
    setCart(cart.filter((_, i) => i !== index));

  const handleEdit = (index) => {
    setSelectedProduct({
      type: cart[index].productType.toLowerCase(),
      name: cart[index].productType,
    });
    setEditIndex(index);
    setCurrentPage("product");
  };

  const handleCheckout = () => setCurrentPage("checkout");

  const handleBack = () => {
    if (currentPage === "product" || currentPage === "checkout") {
      setCurrentPage("home");
    }
  };

  const openCart = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);

  return (
    <Routes>
      <Route
        path="/"
        element={
          currentPage === "home" ? (
            <div
              style={{
                maxWidth: "1200px",
                margin: "0 auto",
                padding: "20px",
              }}
            >
              <Home onProductSelect={handleProductSelect} />

              {cart.length > 0 && (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={openCart}
                    sx={{
                      position: "fixed",
                      bottom: 20,
                      right: 20,
                      borderRadius: 3,
                      py: 1.2,
                      px: 2.5,
                      boxShadow: 3,
                      fontWeight: 700,
                      zIndex: 1000,
                    }}
                  >
                    🛒 View Cart ({cart.length})
                  </Button>

                  <Dialog
                    open={isCartOpen}
                    onClose={closeCart}
                    fullWidth
                    maxWidth="md"
                  >
                    <DialogTitle
                      sx={{
                        m: 0,
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      🛒 Your Cart
                      <IconButton onClick={closeCart}>
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>

                    <DialogContent dividers>
                      <Cart
                        cart={cart}
                        onRemove={handleRemove}
                        onEdit={handleEdit}
                        onCheckout={() => {
                          handleCheckout();
                          closeCart();
                        }}
                      />
                    </DialogContent>
                  </Dialog>
                </>
              )}
            </div>
          ) : currentPage === "product" && selectedProduct ? (
            <ProductInputPage
              product={selectedProduct}
              onAddToCart={handleAddToCart}
              onBack={handleBack}
            />
          ) : currentPage === "checkout" ? (
  <CheckoutForm
    cart={cart}
    onBack={handleBack}
    onSuccess={() => {
      setCart([]);                 // ✅ clear cart
      localStorage.removeItem("cart");
      setCurrentPage("home");      // ✅ go home (no redirect)
      setIsCartOpen(false);        // ✅ close cart dialog
    }}
  />
) : null
        }
      />

      <Route path="/order-success" element={<OrderSuccess />} />
      <Route path="/order-fail" element={<OrderFail />} />
      <Route path="/order-cancel" element={<OrderCancel />} />
      <Route path="/term" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/refund" element={<RefundApplication />} />
      <Route
        path="/refund-cancellation"
        element={<RefundCancellationPolicy />}
      />
    </Routes>
  );
}

/* ---------------- Root App ---------------- */

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
